import React from 'react'
import { Link } from 'gatsby'

const ServiceMenuContent = ({ item }) => (
  <div className="service-mega__item">
    {item.icon && (
      <picture>
        <source
          type="image/webp"
          srcSet={`/assets/images/common/${item.icon}.webp`}
        />
        <img src={`/assets/images/common/${item.icon}.png`} alt="" />
      </picture>
    )}
    <span>{item.label}</span>
  </div>
)

const ServiceMenuItem = ({ item }) => {
  if ('to' in item) {
    return (
      <Link to={item.to} className="service-mega__link">
        <ServiceMenuContent item={item} />
      </Link>
    )
  }

  if ('href' in item) {
    if (item.external) {
      return (
        <a
          href={item.href}
          className="service-mega__link"
          target="_blank"
          rel="noreferrer"
        >
          <ServiceMenuContent item={item} />
        </a>
      )
    }
    return (
      <a href={item.href} className="service-mega__link">
        <ServiceMenuContent item={item} />
      </a>
    )
  }

  return (
    <div className="service-mega__link service-mega__link--disabled">
      <ServiceMenuContent item={item} />
    </div>
  )
}

export default ServiceMenuItem
